import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import * as Editors from "../editors";
export default function PropInput({ prop, onChange, action, sources }) {
  const Input = Editors[prop.editor];
  const [params, setParams] = useState(null);

  useEffect(() => {
    const params = { ...prop.editorParams };
    if (params.type) {
      params.type = action.props[params.type]
        ? action.props[params.type]
        : params.type;
    }
    setParams(params);
  }, [prop, action]);

  const handleChange = (v) => {
    const _action = { ...action };
    _action.props[prop.name] = v;
    onChange(_action);
  };

  if (!Input || !params) {
    return null;
  }
  return (
    <div className={styles.propInput}>
      <div className={styles.propTitle}>{prop.displayName}</div>
      <Input
        value={action.props[prop.name]}
        onChange={handleChange}
        params={params}
        sources={sources}
      />
      <div className={styles.propHelp}>{prop.help}</div>
    </div>
  );
}
